import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgModel, ValidationErrors } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatError, MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { DynamicFormOption } from '@ng-dynamic-forms/core';
import { CustomDynamicFormControlComponent } from '../custom-dynamic-form-control.component';
import { EditEventDetail, SelectEditModel } from './select-edit.model';

export class EditEvent<T> extends CustomEvent<EditEventDetail<T>> {
  constructor(typeArg: string, eventInitDict?: CustomEventInit<EditEventDetail<T>>) {
    super(typeArg, eventInitDict);
  }
}

@Component({
  selector:    'gsm-select-edit',
  templateUrl: './select-edit.component.html',
  styleUrls:   ['./select-edit.component.scss'],
  standalone:  true,
  imports:     [
    MatFormField,
    NgIf,
    MatLabel,
    MatSelect,
    FormsModule,
    NgFor,
    MatOption,
    MatHint,
    MatError,
    MatIconButton,
    MatIcon,
    AsyncPipe
  ]
})
export class SelectEditComponent extends CustomDynamicFormControlComponent<SelectEditModel<any>> implements OnInit {
  private _selectModel: NgModel;
  @ViewChild('selectModel')
  set selectModel(model: NgModel) {
    this._selectModel = model;
    if (this.model.additional?.immediateValidation) {
      this._markTouched();
    }
  }

  get selectModel(): NgModel {
    return this._selectModel;
  }

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected onModelChange() {
    if (this.model.additional?.immediateValidation) {
      this._markTouched();
    }
  }

  private _markTouched() {
    if (this.selectModel) {
      this.selectModel.control.markAsTouched();
    }
  }

  onChange() {
    this.group.controls[this.model.id].setErrors(this._getErrors());
    this.change.emit(this.model.value);
  }

  onEditClick() {
    const customEventType = this.model.eventName || 'open-dialog';
    const customEvent = new EditEvent(customEventType, {
      detail: {
        // clone value to avoid accidental modification
        data:    JSON.parse(JSON.stringify(this.model.value)),
        resolve: val => this._onModelEdit(val)
      }
    });
    this.customEvent.emit({
      customEvent,
      customEventType
    });
  }

  get isEditable(): boolean {
    return !this.model.disabled && this.model.value && this.model.isEditableFn(this.model.value);
  }

  getLabel(option: Partial<DynamicFormOption<any>>): string {
    const labelFn = this.model.displayLabelFn;
    return typeof labelFn === 'function' ? labelFn(option?.value) : option?.label;
  }

  private _getErrors(): ValidationErrors {
    if (this.model.required && !this.model.value) {
      return {required: true};
    }
    return null;
  }

  private _onModelEdit(value: any) {
    this.model.value = value;
    this.model.options = this.model.options.map(option => (this.model.compareWithFn(value, option.value) ? {value} : option));
    this.onChange();
  }
}
